import { createDecorator } from '../../../../../platform/instantiation/common/instantiation.js';
const INotebookCellOutlineProviderFactory = ( createDecorator('INotebookCellOutlineProviderFactory'));
export { INotebookCellOutlineProviderFactory };
